import { useState, type FormEvent } from 'react'
import { useMutation } from '@tanstack/react-query'
import { Modal } from '../../components/ui/Modal'
import { Field } from '../../components/ui/Field'
import { Input } from '../../components/ui/Input'
import { Button } from '../../components/ui/Button'
import { usersApi } from '../../api/users.api'
import { ApiError } from '../../api/client'
import { toast } from '../../store/toastStore'

export function ResetPasswordModal({ userId, onClose }: { userId: string; onClose: () => void }) {
  const [newPassword, setNewPassword] = useState('')
  const [error, setError] = useState<string | null>(null)

  const mutation = useMutation({
    mutationFn: () => usersApi.resetPassword(userId, newPassword),
    onSuccess: () => {
      toast.success('Passwort zurückgesetzt. Der Benutzer wurde aus allen Sessions abgemeldet.')
      onClose()
    },
    onError: (err) => setError(err instanceof ApiError ? err.message : 'Zurücksetzen fehlgeschlagen.'),
  })

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    setError(null)
    mutation.mutate()
  }

  return (
    <Modal
      title="Passwort zurücksetzen"
      onClose={onClose}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Abbrechen
          </Button>
          <Button variant="primary" onClick={onSubmit} loading={mutation.isPending}>
            Zurücksetzen
          </Button>
        </>
      }
    >
      <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
        {error ? <div style={{ color: 'var(--danger)', fontSize: 'var(--text-sm)' }}>{error}</div> : null}
        <Field label="Neues Passwort" htmlFor="newPassword" hint="Mindestens 10 Zeichen">
          <Input
            id="newPassword"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={10}
            autoFocus
          />
        </Field>
      </form>
    </Modal>
  )
}
